import { ComponentRef, ElementRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {EsriReactiveUtils} from "../../../../config/esri.module";

export class BasePopupComponent {
  public componentRef: ComponentRef<BasePopupComponent>;

  public setBaseProperties(
    event: any,
    mapView: __esri.MapView,
    element: ElementRef,
    collapseEnabled: boolean,
    translateService: TranslateService,
    enableDocking: boolean,
    popupTitle: string,
    enableDefaultActions = false
  ) {
    this.setPopupContent(
      event,
      mapView,
      element,
      collapseEnabled,
      translateService,
      enableDocking,
      popupTitle,
      enableDefaultActions
    );
  }

  private setPopupContent(
    event: any,
    mapView,
    element: ElementRef,
    collapseEnabled: boolean,
    translateService: TranslateService,
    enableDocking: boolean,
    popupTitle: string,
    enableDefaultActions: boolean
  ) {
    // set Title
    translateService.get(popupTitle).subscribe(title => {
      mapView.popup.title = title;
    });

    // Set content
    mapView.popup.content = element.nativeElement;

    // set dock options
    mapView.popup.dockOptions = {
      position: 'bottom-right',
    };

    EsriReactiveUtils.watch(
      () => mapView.popup.viewModel !== undefined,
      () => {
        mapView.popup.viewModel.includeDefaultActions = enableDefaultActions;
      }
    );

    if (mapView.popup.viewModel) {
      mapView.popup.viewModel.includeDefaultActions = enableDefaultActions;
    }

    // set popup location
    mapView.popup.dockOptions.buttonEnabled = enableDocking;
    mapView.popup.location = event.mapPoint;
    mapView.popup.visible = true;
    mapView.popup.visibleElements = {
      collapseButton: collapseEnabled,
    }
  }

  /**
   * @function linkComponentRef
   * @param {ComponentRef<UserComponent>} ref
   * @description Link this component reference inside
   * itself for later usage.
   */
  public linkComponentRef(ref: ComponentRef<BasePopupComponent>) {
    this.componentRef = ref;
  }

  /**
   * @function destroySelf
   * @description First notify with onComponentDestroySubject that this component
   * will be destroyed. Destroy self and the widget reference from DOM and also from memory
   */
  public destroySelf() {
    this.componentRef.destroy();
  }
}
